(function () {
  'use strict';
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initTk2(root) {
    var sections = (root || document).querySelectorAll('[data-hv2-tk2]');
    Array.prototype.forEach.call(sections, function (section) {
      if (section.__hv2Tk2) return;
      section.__hv2Tk2 = true;

      var cards = section.querySelectorAll('.hv2-tk__card');
      var previewOn = section.getAttribute('data-hv2-tk-preview') !== 'false';
      var visible = [];

      function cardVideo(c) { return c.querySelector('.hv2-tk__media video'); }
      function attachSrc(v) {
        if (v && !v.src && v.getAttribute('data-src')) v.src = v.getAttribute('data-src');
      }
      function muteCard(c) {
        var v = cardVideo(c);
        if (v) v.muted = true;
        c.setAttribute('data-muted', 'true');
      }
      function playPreview(c) {
        var v = cardVideo(c);
        if (!v) return;
        attachSrc(v);
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var c = entry.target;
            var v = cardVideo(c);
            var idx = visible.indexOf(c);
            if (entry.isIntersecting) {
              if (idx === -1) visible.push(c);
              if (v && previewOn && !REDUCED) playPreview(c);
            } else {
              if (idx !== -1) visible.splice(idx, 1);
              if (v) { v.pause(); muteCard(c); }
            }
          });
        }, { threshold: 0.35 });
        Array.prototype.forEach.call(cards, function (c) { io.observe(c); });
      }

      var modal = section.querySelector('.hv2-tk-modal');
      if (modal && !modal.__hv2Portaled) {
        /* escape ancestor stacking contexts so nothing can cover the player */
        modal.__hv2Portaled = true;
        modal.classList.add('hv2-tk-modal--pip');
        document.body.appendChild(modal);
      }
      var stageVideo = modal ? modal.querySelector('video') : null;
      var chip = modal ? modal.querySelector('.hv2-tk-modal__chip') : null;
      var chipImg = chip ? chip.querySelector('img') : null;
      var chipLabel = chip ? chip.querySelector('span') : null;
      var current = -1;
      var items = [];
      var modalCaption = modal ? modal.querySelector('.hv2-tk-modal__caption') : null;
      var modalMute = modal ? modal.querySelector('[data-modal-mute]') : null;
      Array.prototype.forEach.call(cards, function (c) {
        var cap = c.querySelector('.hv2-tk__caption');
        items.push({
          src: c.getAttribute('data-hv2-full') || c.getAttribute('data-hv2-src') || '',
          poster: c.getAttribute('data-hv2-poster') || '',
          caption: cap ? cap.textContent : '',
          productUrl: c.getAttribute('data-hv2-product-url') || '',
          productTitle: c.getAttribute('data-hv2-product-title') || '',
          productImg: c.getAttribute('data-hv2-product-img') || ''
        });
      });

      function pauseAll() {
        Array.prototype.forEach.call(cards, function (c) {
          var v = cardVideo(c);
          if (v) v.pause();
          muteCard(c);
        });
      }
      function resumeVisible() {
        if (!previewOn || REDUCED) return;
        visible.forEach(function (c) { playPreview(c); });
      }
      function show(i) {
        if (!items.length || !stageVideo) return;
        current = (i + items.length) % items.length;
        var it = items[current];
        if (!it.src) {
          if (chip) chip.hidden = true;
          if (modalCaption) modalCaption.hidden = true;
          return;
        }
        stageVideo.src = it.src;
        if (it.poster) stageVideo.poster = it.poster;
        stageVideo.muted = false;
        if (modalMute) modalMute.setAttribute('data-muted', 'false');
        if (modalCaption) {
          modalCaption.textContent = it.caption || '';
          modalCaption.hidden = !it.caption;
        }
        var p = stageVideo.play();
        if (p && p.catch) p.catch(function () {});
        if (chip) {
          if (it.productUrl && it.productTitle) {
            chip.href = it.productUrl;
            if (chipLabel) chipLabel.textContent = it.productTitle;
            if (chipImg) {
              if (it.productImg) { chipImg.src = it.productImg; chipImg.hidden = false; }
              else chipImg.hidden = true;
            }
            chip.hidden = false;
          } else {
            chip.hidden = true;
          }
        }
      }
      function openModal(i) {
        if (!modal) return;
        pauseAll();
        modal.classList.add('is-open');
        show(i);
      }
      function closeModal() {
        modal.classList.remove('is-open');
        stageVideo.pause();
        stageVideo.removeAttribute('src');
        stageVideo.load();
        resumeVisible();
      }

      Array.prototype.forEach.call(cards, function (c, i) {
        var muteBtn = c.querySelector('[data-hv2-mute]');
        if (muteBtn) {
          muteBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            var v = cardVideo(c);
            if (!v) return;
            if (c.getAttribute('data-muted') === 'true') {
              Array.prototype.forEach.call(cards, function (o) { if (o !== c) muteCard(o); });
              attachSrc(v);
              v.muted = false;
              c.setAttribute('data-muted', 'false');
              var p = v.play();
              if (p && p.catch) p.catch(function () {});
            } else {
              muteCard(c);
            }
          });
        }
        var expandBtn = c.querySelector('[data-hv2-expand]');
        if (expandBtn) expandBtn.addEventListener('click', function (e) { e.stopPropagation(); openModal(i); });
        c.addEventListener('click', function () { openModal(i); });
        c.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openModal(i); }
        });
      });

      if (modal) {
        var closeBtn = modal.querySelector('.hv2-tk-modal__close');
        var prevBtn = modal.querySelector('.hv2-tk-modal__nav--prev');
        var nextBtn = modal.querySelector('.hv2-tk-modal__nav--next');
        if (closeBtn) closeBtn.addEventListener('click', closeModal);
        if (prevBtn) prevBtn.addEventListener('click', function () { show(current - 1); });
        if (nextBtn) nextBtn.addEventListener('click', function () { show(current + 1); });
        if (modalMute) {
          modalMute.addEventListener('click', function () {
            stageVideo.muted = !stageVideo.muted;
            modalMute.setAttribute('data-muted', stageVideo.muted ? 'true' : 'false');
          });
        }
        /* click anywhere outside the player closes it; clicking another
           card switches video instead (its own handler opens it) */
        document.addEventListener('click', function (e) {
          if (!modal.classList.contains('is-open')) return;
          if (modal.contains(e.target)) return;
          if (e.target.closest && e.target.closest('.hv2-tk__card')) return;
          closeModal();
        });
        document.addEventListener('keydown', function (e) {
          if (!modal.classList.contains('is-open')) return;
          if (e.key === 'Escape') closeModal();
          else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') show(current - 1);
          else if (e.key === 'ArrowDown' || e.key === 'ArrowRight') show(current + 1);
        });
        stageVideo.addEventListener('ended', function () { show(current + 1); });
        var touchY = null;
        modal.addEventListener('touchstart', function (e) { touchY = e.touches[0].clientY; }, { passive: true });
        modal.addEventListener('touchend', function (e) {
          if (touchY === null) return;
          var dy = e.changedTouches[0].clientY - touchY;
          touchY = null;
          if (Math.abs(dy) > 48) show(current + (dy < 0 ? 1 : -1));
        }, { passive: true });
      }
    });
  }

  function boot() { initTk2(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) { initTk2(e.target); });
})();
